import * as React from 'react'

import { Box, Icon } from '@factorialco/deprecated-design-system'

function DropdownArrow() {
  return (
    <Box width="s48" flexDirection="column" justifyContent="center" alignItems="center">
      <Icon.Small icon="caret-down" />
    </Box>
  )
}

export default React.memo(DropdownArrow)
